import React, { useState } from 'react';
import { Form, Link } from 'components';
import { api, isEmail } from 'helpers';
import css from './sign-up.scss';

export function SignUp(props) {
  const [ state, setState ] = useState({});

  async function submit({ values, setError, setPending, setSuccess }) {
    if (!values.email) {
      return setError('email', 'please enter your email');
    } else if (!isEmail(values.email)) {
      return setError('email', 'please enter valid email');
    }
    setPending();
    try {
      await api('/free-course', {
        name: values.name,
        email: values.email,
      });
      setSuccess();
    } catch ({ error }) {
      setError('email', 'Server error. Please try again later');
    }
    setPending(false);
  }

  return (
    <div className={css.section}>
      <Form onSubmit={submit} state={state} setState={setState} className={[css.form, props.visible && css.visible].join(' ')} autoComplete="off">
        <h4>Sign up to a free course</h4>
        <p><Form.Text name="email" label="Your Email" /></p>
        <p><Form.Text name="name" label="Your Name" /></p>
        <p><Form.Submit>Get Free Course</Form.Submit></p>
        <p className={css.footer}>
          We respect and protect your privacy. <br />
          View our <Link to="/privacy/">privacy policy.</Link>
        </p>
        { state.success &&
          <div className={css.cover}>
            <p>You've been successfully signed up!</p>
          </div>
        }
      </Form>
    </div>
  );
}
